<div class="cockpit-container">
  <!-- 🔝 Top Menu -->
  <div class="top-menu">
    <button (click)="toggleLeft()">☰</button>
    <button (click)="toggleRight()">👥</button>
    <button (click)="toggleChat()">💬</button>
    <button (click)="openCockpitDesigner()"> cockpit designer </button> 
    <span class="title">Cockpit</span>
  </div>

  <!-- 🔲 Main Area -->
  <div class="main-content">
    <!-- ⬅️ Left Sidebar -->
    <div class="left-sidebar" [class.open]="leftOpen">
      @if (leftOpen) {
        <p>Menu Item 1</p>
        <p>Menu Item 2</p>
      }
    </div>

    <!-- 🎥 Center -->
    <div class="center-area">
      <div class="broadcast-controls">
        <button (click)="startPublish()">Publish</button>
        <button (click)="joinBroadcast()">Join</button>
      </div>

      <div class="video-wrapper">
         @if(store.videoConfig().videoEnabled) {
        <app-video-device-player
          [stream]="remoteStream()"
          deviceName="test"
          [isActive]="true"
          (playerClick)="onPlayerClick()"
        >
        </app-video-device-player>
      }
      </div>
      @for (row of cockpitService.cockpitLayout()?.rows ?? []; track row.id; let rowIndex = $index) {
        
      <div
        (click)="handleRowClick(row.id)"
        class="cockpit-row"
        [style.margin-right.px]="row.properties.marginRight"
        [style.margin-left.px]="row.properties.marginLeft"
        [style.margin-top.px]="row.properties.marginTop"
        [style.margin-bottom.px]="row.properties.marginBottom"
        [style.padding-right.px]="row.properties.paddingRight"
        [style.padding-left.px]="row.properties.paddingLeft"
        [style.padding-top.px]="row.properties.paddingTop"
        [style.padding-bottom.px]="row.properties.paddingBottom"
        [style.height.px]="row.properties.height"
        [style.width]="`calc(100% - ${(+row.properties.marginLeft) + (+row.properties.marginRight)}px)`"
        [style.grid-template-columns]="'repeat(' + row.columns.length + ', 1fr)'"
      >
        @for (item of row.columns; track item.id; let i = $index) {
          <div class="grid-item" [style.grid-column]="i + 1 + ' / ' + (i + 2)">
            <app-cockpit-component-renderer
              [componentsList]="item.components"
              [cellId]="item.id"
              [rowId]="row.id"
              [columnIndex]="i"
              [columnId]="item.id"
            >
            </app-cockpit-component-renderer>
          </div>
        }
      </div>
    }
    </div>

    <!-- ➡️ Right Panel -->
    <div class="right-panel" >
      <p>Other connections</p>

      @for (i of [1, 2, 3]; track i) {
        <div class="mini-video">placeholder</div>
      }
    </div>
  </div>

  <!-- 💬 Bottom Chat -->
  @if(chatOpen) {<div class="bottom-chat">Chat Placeholder</div>}
</div>
